import axios from "axios"; // Mengimpor axios untuk melakukan permintaan HTTP
import { getUserData } from "./config"; // Mengimpor getUserData dari config.js

const HOSTNAME = process.env.REACT_APP_API_URL || "http://localhost:8080";

const API_SERVICES = {
  RoomDepositWaiting: `${HOSTNAME}/roomdeposit/waiting`, // Endpoint untuk mendapatkan status deposit yang menunggu
  RoomDepositSubtotal: `${HOSTNAME}/roomdeposit/subtotal`,
  UpdateRoomDeposit: `${HOSTNAME}/roomdeposit/updatedep`, // Endpoint untuk memperbarui status deposit
  UpdateDPST: `${HOSTNAME}/roomdeposit/updatedpst`,
};

export const getRoomDepositWaiting = async () => {
  try {
    const userData = getUserData(); // Pastikan token valid dan ambil data pengguna

    const url = `${API_SERVICES.RoomDepositWaiting}`; // Endpoint untuk mendapatkan status deposit yang menunggu
    const response = await axios.post(
      url,
      {},
      {
        // Mengirim data kosong
        headers: {
          Authorization: `Bearer ${userData.token}`,
          "Content-Type": "application/json",
        },
      }
    );

    return response.data;
  } catch (error) {
    console.error("Error fetching room deposit waiting:", error.message);
    throw error;
  }
};

export const getRoomDepositSubtotal = async (depositData) => {
  try {
    const userData = getUserData(); // Pastikan token valid dan ambil data pengguna

    const url = `${API_SERVICES.RoomDepositSubtotal}`; // Endpoint untuk mendapatkan status deposit yang menunggu
    const response = await axios.post(url, depositData, {
      // Mengirim data kosong
      headers: {
        Authorization: `Bearer ${userData.token}`,
        "Content-Type": "application/json",
      },
    });

    return response.data;
  } catch (error) {
    console.error("Error fetching room deposit waiting:", error.message);
    throw error;
  }
};

// Fungsi untuk memperbarui deposit kamar menggunakan PUT
export const updateRoomDeposit = async (depositData) => {
  try {
    const userData = getUserData(); // Pastikan token valid dan ambil data pengguna

    const url = `${API_SERVICES.UpdateRoomDeposit}`; // Endpoint untuk memperbarui deposit
    const response = await axios.put(url, depositData, {
      // Mengirim data deposit yang perlu diperbarui
      headers: {
        Authorization: `Bearer ${userData.token}`,
        "Content-Type": "application/json",
      },
    });

    return response.data; // Mengembalikan data response setelah update berhasil
  } catch (error) {
    console.error("Error updating room deposit:", error.message);
    throw error;
  }
};

// Fungsi untuk memperbarui deposit kamar menggunakan PUT
export const updateDPST = async (data) => {
  try {
    const userData = getUserData(); // Pastikan token valid dan ambil data pengguna

    const url = `${API_SERVICES.UpdateDPST}`; // Endpoint untuk memperbarui deposit
    const response = await axios.put(url, data, {
      // Mengirim data deposit yang perlu diperbarui
      headers: {
        Authorization: `Bearer ${userData.token}`,
        "Content-Type": "application/json",
      },
    });

    return response.data; // Mengembalikan data response setelah update berhasil
  } catch (error) {
    console.error("Error updating room deposit:", error.message);
    throw error;
  }
};

